import {Component} from '@angular/core';
import {ModalService} from "../../../../services/modal.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-add-card-success-dialog',
  templateUrl: './add-card-success-dialog.component.html',
  styleUrls: ['./add-card-success-dialog.component.scss']
})
export class AddCardSuccessDialogComponent {
  constructor(
    private modalService: ModalService,
    private router: Router
  ) {
  }

  closeModal() {
    this.modalService.closeModal()
  }

  goToRoleList() {
    this.closeModal()
    this.router.navigate(['/saved-card-list'])
  }
}
